// extracted by mini-css-extract-plugin
export default {"social-share-buttons":"_1fKd7","socialShareButtons":"_1fKd7","social-share-group":"_2AGIV","socialShareGroup":"_2AGIV","social-share-button":"_1yaPT","socialShareButton":"_1yaPT"};